module.exports = (() => {
    if (process.env.REACT_APP_ENV === 'production') {
      return require('./production');
    }
    return require('./dev');
  })();
  